// ProjectHud.tsx
import { Link, useRoute } from "wouter";
import { pages } from "../data/pageData";
import { useDomain } from "../helpers/DomainContext";
import styles from "../styles/hud.module.css";
import { useEffect } from "react";

export function ProjectHud() {
    const [, params] = useRoute("/projects/:id?");
    const { showPersonalInfo } = useDomain();
    const project = pages.find((p) => p.id === (params?.id || "dam"));


    if (!project) return null;

    return (
        <>
            <div className={styles.topText}>
                <div className={styles.projectInfo}>
                    <h1 className={styles.title}>{project.title}</h1>
                    {project.shortDescription && (
                        <p className={styles.subtitle}>
                            {project.shortDescription}
                        </p>
                    )}
                    {project.tags && (
                        <p className={styles.tags}>
                            {project.tags.join(", ")}
                        </p>
                    )}
                </div>
                <Link
                    className={styles.seeMoreButton}
                    href={`/projects/${project.id}/info`}
                >
                    More Info →
                </Link>
            </div>

            {showPersonalInfo && (
                <Link className={styles.backButton} href="/home">
                    ← Back to home
                </Link>
            )}
        </>
    );
}